import React from 'react';

import { WaitingForCall, Validation, ExitModule, NeedHelp } from '@modals';

export const ModalsPlaceholder: React.FC = () => {
	return (
		<>
			<WaitingForCall />
			<Validation />
			<ExitModule />
			<NeedHelp />
		</>
	);
};
